module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-control field"
  }, [(_vm.image === null) ? _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selecting = true
      }
    }
  }, [_vm._v("Select image")])])])]) : _vm._e(), _vm._v(" "), (_vm.image !== null && !_vm.selecting) ? _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('img', {
    attrs: {
      "src": _vm.image.thumbnail_path
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "level-item"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.image.name) + "." + _vm._s(_vm.image.extension) + "\n                    "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        _vm.selecting = true
      }
    }
  }, [_vm._v("Change image")]), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.clearImage()
      }
    }
  }, [_vm._v("Clear image")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.selecting) ? _c('div', [_c('div', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.selecting = false
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "image-list"
  }, _vm._l((_vm.images), function(img) {
    return _c('div', {
      staticClass: "image-tile",
      on: {
        "click": function($event) {
          return _vm.selectImage(img)
        }
      }
    }, [_c('div', {
      staticClass: "level",
      staticStyle: {
        "height": "50px"
      }
    }, [_c('div', {
      staticClass: "level-left"
    }, [_c('div', {
      staticClass: "level-item"
    }, [_c('img', {
      staticStyle: {
        "max-width": "50px"
      },
      attrs: {
        "src": img.thumbnail_path
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "level-item image-description"
    }, [_vm._v("\n                            " + _vm._s(img.name) + "." + _vm._s(img.extension) + "\n                        ")])])])])
  }), 0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-item"
  }, [_c('div', {
    staticClass: "no-image"
  }, [_vm._v("\n                    No Image\n                ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb2780a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/misc/ImageControl.vue
// module id = 578
// module chunks = 0